export default __webpack_public_path__ + "static/media/alfie_logo.107158ac.png";